<template>
<div class="chapter">
<div class="inner_page">
<p class="parttitle"><a id="page_17">PART ONE</a></p><a id="page_17">
<p class="parttitle1"><b>THE INVENTION OF OLD TOWN</b></p>
<p class="partno">1917-1956</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?5b0ac47c